export default "__VITE_PUBLIC_ASSET__2a93341e__"